import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Banner from "../components/Banner";
import MenuManizales from "../components/MenuManizales";
import Sponsors from "../components/Sponsors";
import TableIndividual from "../components/TableIndividual";
import "../assets/styles/containers/Results.sass";

const ResultsManizales = () => {
  const [category, setCategory] = useState("");
  const [sponsors, setSponsors] = useState([]);
  const [data, setData] = useState({
    finish: [],
    dnfinish: [],
    femaleebike: [],
    maleebike: [],
    travesia: [],
    dnftravesia: [],
    categories: [],
  });
  const [racers, setRacers] = useState({
    finish: [],
    dnfinish: [],
    femaleebike: [],
    maleebike: [],
    travesia: [],
    dnftravesia: [],
  });
  const showFemaleEbikes = category === "E-BIKE FEMENINO" || category === "";
  const showMaleEbikes = category === "E-BIKE MASCULINO" || category === "";
  const showTravesia = category === "TRAVESIA" || category === "";


  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/results/2024/manizales`)
      .then((res) => res.json())
      .then((res) => {
        const finish = res.results.racers.filter((item) => item.dnf === "N");
        let dnfinish = res.results.racers.filter((item) => item.dnf === "S");
        dnfinish = dnfinish.sort((a, b) => a.number - b.number);

        // TRAVESIA
        const travesia = res.results.travesia.filter((item) => item.dnf === "N");
        const dnfTravesia = res.results.travesia.filter((item) => item.dnf === "S");

        setRacers({
          finish: finish,
          dnfinish: dnfinish,
          femaleebike: res.results.femaleebike,
          maleebike: res.results.maleebike,
          travesia: travesia,
          dnftravesia: dnfTravesia,
        });
        setData({
          finish: finish,
          dnfinish: dnfinish,
          femaleebike: res.results.femaleebike,
          maleebike: res.results.maleebike,
          travesia: travesia,
          dnftravesia: dnfTravesia,
        });
        setSponsors(res.sponsors);
      });
  }, []);

  const setCategoryState = (category) => {
    setCategory(category);

    if (category === "") {
      return Promise.resolve(
        setData({
          ...data,
          finish: racers.finish,
          dnfinish: racers.dnfinish,
          femaleebike: racers.femaleebike,
          maleebike: racers.maleebike,
          travesia: racers.travesia,
          dnftravesia: racers.dnftravesia,
        })
      );
    }

    return Promise.resolve(
      setData({
        ...data,
        finish: racers.finish.filter((item) => item.category_es === category),
        dnfinish: racers.dnfinish.filter((item) => item.category_es === category),
        femaleebike: racers.femaleebike.filter((item) => item.category_es === category),
        maleebike: racers.maleebike.filter((item) => item.category_es === category),
        travesia: racers.travesia.filter((item) => item.category_es === category),
        dnftravesia: racers.dnftravesia.filter((item) => item.category_es === category),
      })
    );
  };

  const setSearchState = (keyword) => {
    if (keyword) {
      return Promise.resolve(
        setData({
          ...data,
          finish: data.finish.filter((racer) => racer.racer.includes(keyword.toUpperCase())),
          dnfinish: data.dnfinish.filter((racer) => racer.racer.includes(keyword.toUpperCase())),
          femaleebike: data.femaleebike.filter((racer) => racer.racer.includes(keyword.toUpperCase())),
          maleebike: data.maleebike.filter((racer) => racer.racer.includes(keyword.toUpperCase())),
          travesia: data.travesia.filter((racer) => racer.racer.includes(keyword.toUpperCase())),
          dnftravesia: data.dnftravesia.filter((racer) => racer.racer.includes(keyword.toUpperCase())),
        })
      );
    }
    return;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let target = event.target;

    try {
      await setCategoryState(target.categorias.value);
      if (target.search_racer.value) {
        await setSearchState(target.search_racer.value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout>
      <Banner id={15} city="manizales" thumb="/manizales/logo_manizales.png" />
      <MenuManizales />
      <div className="row content-manizales">
        <div className="container">
          <div className="row no-gutters">
            <form onSubmit={handleSubmit} className="results-form">
              <div className="results-form__inputs">
                <div className="results-form__container">
                  <label htmlFor="resultados" className="col-sm-4 ptop">
                    Año
                  </label>
                  <select name="resultados" id="resultados" className="form-control">
                    <option value="2024">2024</option>
                  </select>
                </div>

                <div className="results-form__container">
                  <label htmlFor="categorias" className="col-sm-4 ptop">
                    Categoría
                  </label>
                  <select name="categorias" id="categorias" className="form-control">
                    <option value="">TODAS</option>
                    <option value="ABIERTO MASCULINO">ABIERTO MASCULINO</option>
                    <option value="ABIERTO FEMENINO">ABIERTO FEMENINO</option>
                    <option value="MASTER 30+">MASTER 30+</option>
                    <option value="MASTER 40+">MASTER 40+</option>
                    <option value="GRANDMASTER 50+">GRANDMASTER 50+</option>
                    <option value="GRANDMASTER 60+">GRANDMASTER 60+</option>
                    <option value="MASTER FEMENINO 35+">MASTER FEMENINO 35+</option>
                    <option value="GRAVEL MASCULINO">GRAVEL MASCULINO</option>
                    <option value="E-BIKE MASCULINO">E-BIKE MASCULINO</option>
                    <option value="E-BIKE FEMENINO">E-BIKE FEMENINO</option>
                    <option value="TRAVESIA">TRAVESIA</option>
                  </select>
                </div>

                <div className="results-form__container">
                  <label htmlFor="year" className="col-sm-4 control-label-left">
                    Buscar corredores
                  </label>
                  <input className="form-control" type="text" name="search_racer" />
                </div>
              </div>

              <div className="results-form__cta">
                <button className="results-form__btn --manizales" type="submit">
                  VER RESULTADOS
                </button>
              </div>
            </form>
          </div>

          {data.finish.length > 0 && (
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">
                    2024 - SERIES MANIZALES - GC - CARRERA {category !== "" && `- ${category}`}
                  </h1>
                </div>
              </div>

              <TableIndividual city="manizales" racers={data.finish} />
            </>
          )}

          {data.dnfinish.length > 0 && (
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">
                    2024 - SERIES MANIZALES - GC - CARRERA - NO FINALIZADOR {category !== "" && `- ${category}`}
                  </h1>
                </div>
              </div>

              <TableIndividual city="manizales" racers={data.dnfinish} />
            </>
          )}

          {data.travesia.length > 0 && showTravesia && (
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2024 - SERIES MANIZALES - GC - TRAVESIA</h1>
                </div>
              </div>

              <TableIndividual city="manizales" racers={data.travesia} />
            </>
          )}

          {data.dnftravesia.length > 0 &&(
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">
                    2024 - SERIES MANIZALES - GC - TRAVESIA - NO FINALIZADOR
                  </h1>
                </div>
              </div>

              <TableIndividual city="manizales" racers={data.dnftravesia} />
            </>
          )}

          {data.femaleebike.length > 0 && showFemaleEbikes && (
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2024 - SERIES MANIZALES - GC - CARRERA E-BIKE FEMENINO</h1>
                </div>
              </div>

              <TableIndividual city="manizales" racers={data.femaleebike} />
            </>
          )}

          {data.maleebike.length > 0 && showMaleEbikes && (
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2024 - SERIES MANIZALES - GC - CARRERA E-BIKE MASCULINO</h1>
                </div>
              </div>

              <TableIndividual city="manizales" racers={data.maleebike} />
            </>
          )}
        </div>
      </div>

      {sponsors.length > 0 && <Sponsors customClass="--manizales" items={sponsors} />}
    </Layout>
  );
};

export default ResultsManizales;
